import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import LineSegment from '../../geom/LineSegment';
var MonotoneChainOverlapAction = /*#__PURE__*/function () {
  function MonotoneChainOverlapAction() {
    _classCallCheck(this, MonotoneChainOverlapAction);
    MonotoneChainOverlapAction.constructor_.apply(this, arguments);
  }
  _createClass(MonotoneChainOverlapAction, [{
    key: "overlap",
    value: function overlap() {
      if (arguments.length === 2) {
        var seg1 = arguments[0],
          seg2 = arguments[1];
      } else if (arguments.length === 4) {
        var mc1 = arguments[0],
          start1 = arguments[1],
          mc2 = arguments[2],
          start2 = arguments[3];
        mc1.getLineSegment(start1, this._overlapSeg1);
        mc2.getLineSegment(start2, this._overlapSeg2);
        this.overlap(this._overlapSeg1, this._overlapSeg2);
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._overlapSeg1 = new LineSegment();
      this._overlapSeg2 = new LineSegment();
    }
  }]);
  return MonotoneChainOverlapAction;
}();
export { MonotoneChainOverlapAction as default };